import { useEffect } from "react";
import "../styles/scss/App.scss";

import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";

import Header from "./accessories/Header";
import Home from "./content/Home";
import UserAccount from "./content/UserAccount";
import SideNav from "./accessories/SideNav";
import Settings from "./content/Settings";
import Tasks from "./content/Tasks";
import Expenses from "./content/Expenses";
import Login from "./accessories/Login";

import { useSelector, useDispatch } from "react-redux";

import { firebase } from "../firebase/initFirebase";

import { VscLoading } from "react-icons/vsc";

const themeOptionKey = "THEME_OPTION";

function App() {
    let match = useRouteMatch();

    const { app, user } = useSelector(({ app, user }) => {
        return { app, user };
    });

    const dispatch = useDispatch();

    useEffect(() => {
        // set logout funtion for firebase, in redux
        // assuming we have a firebase component imported
        dispatch({
            type: "USER_SET_FIREBASE_LOGOUT_FUNCTION",
            payload: () => firebase.auth().signOut(),
        });

        const cancelAuthListener = firebase.auth().onIdTokenChanged((u) => {
            dispatch({ type: "USER_SET_USER", payload: u });
            dispatch({ type: "USER_SET_LOADING", payload: false });
        });

        // stop listening on unmount
        return () => cancelAuthListener();
    }, [dispatch]);

    useEffect(() => {
        const storedTheme = localStorage.getItem(themeOptionKey);
        if (storedTheme) {
            dispatch({ type: "APP_SET_THEME", payload: storedTheme });
        } else {
            dispatch({ type: "APP_SET_THEME", payload: "none" });
        }
    }, [dispatch]);

    return (
        <div
            className={`App ${app.theme === "App--light" ? "App--light" : ""}`}
        >
            <Header />
            <div className="page">
                <SideNav />
                <main className="main-content">
                    {!user.user ? (
                        user.loading ? (
                            <VscLoading className="loading-svg" />
                        ) : (
                            <Login firebase={firebase} />
                        )
                    ) : (
                        <Switch>
                            <Route
                                exact
                                path={`${match.path}(eco)?/(home)`}
                                component={Home}
                            />
                            <Route
                                exact
                                path={`${match.path}(eco)?/(home)`}
                                component={Home}
                            />
                            <Route
                                exact
                                path={`${match.path}(eco)?/user-account`}
                                component={UserAccount}
                            />
                            <Route
                                exact
                                path={`${match.path}(eco)?/settings`}
                                component={Settings}
                            />
                            <Route
                                exact
                                path={`${match.path}(eco)?/tasks`}
                                component={Tasks}
                            />
                            <Route
                                exact
                                path={`${match.path}(eco)?/expenses`}
                                component={Expenses}
                            />
                            <Route
                                path=""
                                render={() => (
                                    <Redirect to={`${match.url}eco/home`} />
                                )}
                            />
                        </Switch>
                    )}
                </main>
            </div>
        </div>
    );
}

export default App;
